import uiRouterModule from "@uirouter/angularjs";

import AuthCallbackController from "./AuthCallbackController";
import AuthCallbackModuleConstants from "./Constants";

function AuthCallbackConfiguration($stateProvider) {
    $stateProvider.state(AuthCallbackModuleConstants.rootStateName, {
        url: `/${AuthCallbackModuleConstants.stateUrl}`,
        controller: AuthCallbackController,
        controllerAs: AuthCallbackController.controllerAs,
        template: AuthCallbackController.template
    });
}

AuthCallbackConfiguration.$inject = [
    "$stateProvider"
];

AuthCallbackConfiguration.dependencies = [
    uiRouterModule
];

export default AuthCallbackConfiguration;



//////////////////
// WEBPACK FOOTER
// ./src/views/auth-callback/AuthCallbackConfiguration.js
// module id = 19TQ
// module chunks = 1